
<div mat-dialog-title class="d-flex flex-column position-relative" >
    <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon>close</mat-icon>
    </button>
    
  </div>
  <mat-dialog-content >
    <mat-list>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">info</mat-icon>
        <div mat-line>
          From: <span>{{ data[0].fromDate | date }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >info</mat-icon
        >
        <div mat-line>
          To: <span>{{ data[0].toDate | date }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
         Pack name: <span>{{ data[0].planName }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!-- <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
        <div mat-line>
          Phone number: <span>{{ data[0].phone }}</span>
        </div>
      </mat-list-item> -->
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined"
          >admin_panel_settings</mat-icon
        >
        <div mat-line>
          Free plan: <span>{{ data[0].isItFreePlan == 1 ? 'Yes' : 'No' }}</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
        <div mat-line>
         Subscription status: <span>{{ data[0].subscriptionActive == 1 ? 'Active' : 'Inactive'}}</span>
        </div>
      </mat-list-item>
      
    </mat-list>
  </mat-dialog-content>
  